export default __webpack_public_path__ + "static/media/subscription-logo.d555a882.svg";